export default class ProductForm {
  constructor({ el, data }) {
    // Data set
    this.data = data;
    this.id = data.id;
    this.product = data.product;
    this.variants = data.product.variants;
    this.currentVariant = this.getInitialVariant();

    // Element set
    this.el = el;
    this.price = this.el.querySelectorAll("[data-price]");
    this.priceRange = this.el.querySelector("[data-product-price]");
    this.form = this.el.querySelector("[data-product-form]");
    this.addButton = this.el.querySelector("[data-product-add]");
    this.addBundle = this.el.querySelector("[data-bundle-add]");
    this.addCta = this.el.querySelector("[data-product-cta]");
    this.breadPay = this.el.querySelector("#bread-checkout-btn-product");
    this.breadPayDupe = this.el.querySelector("[data-bread-pay]");
    this.cartSection = document.querySelector("section-cart");
    this.customValueInputContainer = this.el.querySelector(
      "[data-custom-amount]"
    );
    this.customValueInput =
      this.customValueInputContainer?.querySelector("input");

    this.customValueInputValid = true;

    this.input = this.el.querySelector("[data-variant-picker]");
    this.optionName = this.el.querySelector("[data-option-name]");
    this.productGroupContainer = this.el.querySelector("[data-product-group]");
    this.productGroup = this.product.tags?.find((t) => t.includes("group:"));
    this.group = this.productGroup?.split(":")[2];
    this.groupUrl = null;
    this.products = this.productGroup?.split(":")[2];

    // Setup
    this.addItemToCart = this.addItemToCart.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.init();
  }

  init() {
    this.form?.addEventListener("submit", (e) => {
      e.preventDefault();
      this.addItemToCart();
    });

    this.input?.addEventListener("change", this.onVariantChange);

    this.customValueInput.addEventListener("input", (e) => {
      if (!this.customValueInputValid) {
        this.validateCustomValueInput();
      }
      this.disableAtcButtons(!this.customValueInput.validity.valid);
      this.renderProductInfo();
    });

    this.customValueInput.addEventListener("focusout", (e) => {
      this.validateCustomValueInput();
    });

    this.toggleCustomValueInput();
  }

  validateCustomValueInput() {
    this.customValueInputContainer.classList.toggle(
      "error",
      !this.customValueInput.validity.valid
    );

    this.customValueInputValid = this.customValueInput.validity.valid;
    this.disableAtcButtons(!this.customValueInput.validity.valid);
  }

  disableAtcButtons(disabled) {
    this.el.querySelectorAll(".product-form__add-button").forEach((button) => {
      button.disabled = disabled;
    });
  }

  addItemToCart() {
    let id = this.currentVariant?.id.toString().includes("gid")
      ? this.currentVariant?.id.split("/")
      : this.currentVariant?.id;
    id = id.length > 1 ? id[id.length - 1] : id;
    const properties = {};

    if (this.currentVariant?.id === this.data.customValueVariantId) {
      properties._customAmount = this.customValueInput.validity.valid
        ? this.customValueInput.value
        : this.data.customValueDefaultPrice;
    }

    window.addToCart({
      id: this.variants ? id : this.product.id,
      quantity: 1,
      properties,
    });
  }

  updateValue(option, type, value) {
    this.el.querySelectorAll(`[${option}]`).forEach((item) => {
      item[type] = value;
    });
  }

  /**
   * Get initial variant based on URL params
   * @returns variant object
   */

  getInitialVariant() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.variant) {
      const initialVariant = this.variants.filter(
        (variant) => variant.id.toString() === params.variant
      )[0];
      if (initialVariant) return initialVariant;
    }

    return this.variants[0];
  }

  /**
   * Update hidden variant input
   */
  updateVariantInput() {
    const input = this.form?.querySelector('input[name="id"]');
    input.value = this.currentVariant?.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /**
   * Update URL param with current variant ID
   */
  updateURL() {
    if (!this.currentVariant || Shopify.designMode) return;
    let id = this.currentVariant?.id.toString().includes("gid")
      ? this.currentVariant?.id.split("/")
      : this.currentVariant?.id;
    id = id.length > 1 ? id[id.length - 1] : id;

    const url = new URL(window.location);
    url.searchParams.set("variant", id);
    window.history.replaceState({}, "", url);
  }

  /**
   * On variant change
   */
  onVariantChange() {
    this.updateOptions();
    this.updateVariant();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.toggleCustomValueInput();
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.el.querySelectorAll(".product-form__options")
    );
    this.options = fieldsets.map((fieldset) => {
      let inputs = Array.from(fieldset.querySelectorAll("input"));
      this.groupUrl = inputs
        .find((radio) => radio.checked)
        ?.getAttribute("data-product");
      return inputs.find((radio) => radio.checked)?.value;
    });
  }

  /**
   * Update current variant based on current option array
   */
  updateVariant() {
    let variants = this.products?.length ? this.products : this.variants;
    this.currentVariant = variants.find((variant) => {
      let options = variant.options
        ? variant.options
        : variant.selectedOptions.map((o) => o.value);
      return !options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  /**
   * Get section data based on new variant selection for rebuild markup
   */
  renderProductInfo() {
    let image = this.currentVariant?.featured_image
      ? this.currentVariant?.featured_image
      : this.currentVariant?.image;
    this.updateValue("data-variant-image", "src", image?.src);
    this.updateValue("data-variant-image", "srcset", "");
    let price = this.currentVariant?.priceV2?.amount
      ? this.currentVariant?.priceV2?.amount * 100
      : this.currentVariant?.price;

    if (this.currentVariant?.id === this.data.customValueVariantId) {
      const inputPrice =
        parseFloat(this.customValueInput.value).toFixed(2) * 100;
      if (inputPrice > 0) {
        price = inputPrice;
      }
    }

    const comparePrice = this.currentVariant?.compareAtPriceV2?.amount * 100;
    let currentVariantPrice = `<span class="price__regular " >${window.formatMoney(
      price / 100
    )}</span>`;
    currentVariantPrice += comparePrice
      ? `<del class="price__compare">${window.formatMoney(
          comparePrice / 100,
          2
        )}</del>`
      : "";
    this.el.querySelectorAll("[data-price]").forEach((price) => {
      price.innerHTML = currentVariantPrice;
    });

    let currentProduct = this.groupUrl;
    const productUpdated = new CustomEvent("productUpdate", {
      detail: {
        ...(currentProduct && { product: currentProduct }),
        variant: this.currentVariant,
      },
    });
    document.dispatchEvent(productUpdated);
  }

  toggleCustomValueInput() {
    const customValueVariantSelected =
      this.currentVariant?.id === this.data.customValueVariantId;
    this.customValueInputContainer.style.display = customValueVariantSelected
      ? null
      : "none";
    if (customValueVariantSelected) {
      this.customValueInput.focus();
      this.disableAtcButtons(!this.customValueInput.validity.valid);
    } else {
      this.disableAtcButtons(false);
    }
  }
}
